import React from 'react';

import spinner from '../Pokeball.svg'

const Loading = () => {
  return (
    <img src={ spinner } alt="Poke Ball" className="pokeball"/>
  )
}

export default Loading;



// WEBPACK FOOTER //
// ./src/Components/Loading.js